import Vue from 'vue'
import Vuex from 'vuex'
import app from '../../main' // import the instance
import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('Orders', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  orders: [],
  metrics: null,
  liveDashboard: null
}

const mutations = {
  ...crud.mutations,
  SET_METRICS (state, payload) {
    state.metrics = payload
  },
  SET_LIVE_DASHBOARD (state, payload) {
    state.liveDashboard = payload
  }
}

const actions = {
  ...crud.actions,
  async loadPreventiveModuleRecords ({ commit }, { page = 1, category = 'todas', folio = '' }) {
    app.$Progress.start()
    try {
      const response = await axios.get('orders/preventive-module', {
        params: {
          page,
          category,
          folio: folio || undefined
        }
      })
      commit('SET_RECORDS', response.data)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadPreventiveMetrics ({ commit }, params) {
    app.$Progress.start()
    try {
      const response = await axios.get('orders/preventive-metrics', { params })
      commit('SET_METRICS', response.data)
      return response.data
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
      throw e
    } finally {
      app.$Progress.finish()
    }
  },
  async loadLiveDashboard ({ commit }) {
    try {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      const response = await axios.get('orders/live-dashboard', { params: { timezone } })
      commit('SET_LIVE_DASHBOARD', response.data)
      return response.data
    } catch (e) {
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
      throw e
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + `/receptions/${payload}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  }
}

const getters = {
  ...crud.getters,
  orders: state => state.orders,
  metrics: state => state.metrics,
  liveDashboard: state => state.liveDashboard
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
